export class ScreenManagement {
    constructor(uic) {
        this.addScreen = (screen) => {
            screen.bootstrapScreen($('#cbot-screens'));
            this.screens.push(screen);
        };
        this.showScreen = (screenName, options) => {
            let debugLine = "Show " + screenName + " screen";
            this.uic.widget.debug ? console.log(debugLine) : () => { };
            this.resetScreen();
            let screenShown = false;
            for (let screen of this.screens) {
                if (screen.name == screenName) {
                    if (screenName !== this.uic.widget.getStateMachine().screen) {
                        this.uic.widget.track("chat", "view", screenName + "_screen");
                        this.uic.widgetHeaderController.disableEndChatOnCloseButton();
                    }
                    this.uic.widgetHeaderController.showIcons();
                    screen.show(options);
                    screenShown = true;
                }
            }
            if (screenShown) {
                this.uic.widget.getStateMachine().screen = screenName;
                this.uic.cachingService.saveCacheSession(this.uic.widget.getStateMachine());
                this.resizeActiveScreen();
            }
            else {
                console.error("Undefined Screen - Show current screen");
                this.showScreen(this.uic.widget.getStateMachine().screen);
            }
        };
        this.resizeActiveScreen = () => {
            for (let screen of this.screens) {
                if (screen.name == this.uic.widget.getStateMachine().screen) {
                    screen.resizeEvent();
                    screen.resizeExtension();
                }
            }
        };
        this.activateExtension = (extensionName, extensionOptions) => {
            for (let screen of this.screens) {
                screen.activateExtension(extensionName, extensionOptions);
            }
        };
        this.deactivateExtension = (extensionName) => {
            for (let screen of this.screens) {
                screen.deactivateExtension(extensionName);
            }
        };
        this.resetScreen = () => {
            for (let screen of this.screens) {
                screen.hide();
            }
        };
        this.uic = uic;
        this.screens = [];
    }
    deactivateExtensions() {
        for (let screen of this.screens) {
            screen.deactivateExtensions();
        }
    }
}
